/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxDynamoFileSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_DYNAMO_FILE_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class MaxDynamoFileSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxDynamoFileSizeSettingParser.decode(input).map(res => new MaxDynamoFileSizeSetting(res));
    }
    static unsafeDecode(input) {
        return MaxDynamoFileSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxDynamoFileSizeSettingParser.encode(data);
    }
    static schema() {
        return MaxDynamoFileSizeSettingParser.schema();
    }
}
